<div>
  <div class="topo-line"></div>
  <nav class="navbar navbar-light bg-light">
    <a class="nav-link" href="/">{{ "inicio" | translate }} </a>
  </nav>
  <app-title></app-title>
</div>
